import { render } from "./RouteForm.vue?vue&type=template&id=f8f39bfc&scoped=true"
import script from "./RouteForm.vue?vue&type=script&lang=js"
export * from "./RouteForm.vue?vue&type=script&lang=js"

import "./RouteForm.vue?vue&type=style&index=0&id=f8f39bfc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8f39bfc"]])

export default __exports__